import * as React from 'react';
import 'moment-duration-format';

import Flatpickr from 'react-flatpickr';

import 'flatpickr/dist/flatpickr.css';

import moment from 'moment';
import { tl } from '../../services/i18nService';

import * as styles from './DateTimePicker.scss';
import { SIMPLE_DATE_FORMAT_STRING_NO_SECONDS } from '../../store/common/constants';

interface DateTimeProps {
    defaultDateString: string;
    disabled?: boolean;
    onlyDateInput?: boolean;
    onDateFlatpickrOpen?: () => void;
    onDateFlatpickrClose?: () => void;
    noLabel?: boolean;
    open?: boolean;
    onFromConditionChange: (dateTimeString: string) => void;
    style?: React.CSSProperties;
}

interface DateTimeState {
    currentDate: moment.Moment;
}

export class DateTimeOption extends React.PureComponent<DateTimeProps, DateTimeState> {
    private readonly dateFormat = 'YYYY-MM-DD';
    private dateInput: any;
    constructor(props: DateTimeProps) {
        super(props);

        const format = props.onlyDateInput ? this.dateFormat : SIMPLE_DATE_FORMAT_STRING_NO_SECONDS;
        this.state = {
            currentDate: props.defaultDateString
                ? moment.utc(props.defaultDateString, format).local() : undefined,
        };

        this.onDateValueUpdate = this.onDateValueUpdate.bind(this);
        this.onTimeValueUpdate = this.onTimeValueUpdate.bind(this);
    }

    componentDidMount() {
        this.updatePickr();
    }

    componentDidUpdate() {
        this.updatePickr();
    }

    onDateFlatpickrOpen = () => {
        const { onDateFlatpickrOpen } = this.props;
        if (onDateFlatpickrOpen && typeof onDateFlatpickrOpen === 'function') {
            onDateFlatpickrOpen();
        }
    };

    onTimeFlatpickrOpen(selectedDates: Date[], dateStr: string, instance: any) {
        const now = new Date();
        instance.set('defaultHour', now.getHours());
        instance.set('defaultMinute', now.getMinutes());
    }

    onDateValueUpdate(selectedDates: Date[]) {
        if (typeof this.props.onDateFlatpickrClose === 'function') {
            this.props.onDateFlatpickrClose();
        }

        if (selectedDates.length === 0) {
            return;
        }

        const { currentDate } = this.state;
        const newMoment = moment(selectedDates[0]);

        if (currentDate) {
            currentDate.year(newMoment.year());
            currentDate.month(newMoment.month());
            currentDate.date(newMoment.date());
            this.saveVisibleFromCondition();
        } else {
            // set "now" by default
            const now = new Date();
            newMoment.hours(now.getHours());
            newMoment.minutes(now.getMinutes());
            this.setState(
                {
                    currentDate: newMoment,
                },
                () => {
                    this.saveVisibleFromCondition();
                },
            );
        }
    }

    onTimeValueUpdate(selectedDates: Date[]) {
        if (selectedDates.length === 0) {
            return;
        }

        const { currentDate } = this.state;
        const newMoment = moment(selectedDates[0]);

        if (currentDate) {
            currentDate.hours(newMoment.hours());
            currentDate.minutes(newMoment.minutes());
        } else {
            // why select time before date, might as well set the current one
            const newDateTime = moment();
            newDateTime.hours(newMoment.hours());
            newDateTime.minutes(newMoment.minutes());
            newDateTime.seconds(0);
            this.setState({
                currentDate: newDateTime,
            });
        }

        this.saveVisibleFromCondition();
    }

    updatePickr = () => {
        if (this.dateInput) {
            if (this.props.disabled) {
                this.dateInput.node.disabled = true;
            }
            if (this.props.open) {
                setTimeout(
                    () => {
                        this.dateInput.flatpickr.open();
                    },
                    10,
                );
            }
        }
    };

    saveVisibleFromCondition() {
        const { onFromConditionChange, onlyDateInput } = this.props;
        const { currentDate } = this.state;
        if (currentDate) {
            let val = '';
            if (onlyDateInput) {
                val = currentDate.clone().format(this.dateFormat);
            } else {
                val = currentDate.clone().utc().format(SIMPLE_DATE_FORMAT_STRING_NO_SECONDS);
            }
            onFromConditionChange(val);
        }
    }

    render() {
        const dateOptions = {
            dateFormat: 'd/m/Y',
        };
        const timeOptions = {
            enableTime: true,
            noCalendar: true,
            dateFormat: 'h:i K',
        };
        return (
            <div className={styles.customDateTimeWrapper} style={this.props?.style}>
                <div className={`ui input flatpickr ${styles.datePicker}`}>
                    {!this.props.noLabel && tl('workspace.visibilityCondition.date')}
                    <Flatpickr
                        value={this.state.currentDate ? this.state.currentDate.toDate() : undefined}
                        options={dateOptions}
                        onOpen={this.onDateFlatpickrOpen}
                        onClose={this.onDateValueUpdate}
                        ref={(element) => {
                            this.dateInput = element;
                        }}
                    />
                </div>
                {!this.props.onlyDateInput
                && (
                    <div className={`ui input ${styles.timePicker}`}>
                        {tl('workspace.visibilityCondition.time')}
                        <Flatpickr
                            value={this.state.currentDate ? this.state.currentDate.toDate() : undefined}
                            options={timeOptions}
                            onClose={this.onTimeValueUpdate}
                            onOpen={this.onTimeFlatpickrOpen}
                        />
                    </div>
                )}
            </div>
        );
    }
}
